// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false
window.$http = axios
window.hostName =
  process.env.NODE_ENV !== 'development' ? '' : 'http://baifund.com/'

if (!localStorage.lang) {
  localStorage.lang = /zh/.test(navigator.language) ? 'zh' : 'en'
}
(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt =
    'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    docEl.style.fontSize = 20 * (clientWidth / 320) + 'px'
  }

  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  recalc()
  // hack兼容某些特殊机型
  doc.addEventListener('DOMContentLoaded', recalc, false)
  var u = navigator.userAgent
  window.isMobi =
    u.indexOf('Android') > -1 ||
    u.indexOf('Adr') > -1 ||
    !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
})(document, window)

import 'vue-fullpage/vue-fullpage.css'
import VueFullpage from 'vue-fullpage'
Vue.use(VueFullpage)

window.bus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js